import { FC, ReactNode } from 'react';
import { Box, alpha, lighten, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';

import Sidebar from './Sidebar';
import Footer from 'src/components/Footer';

interface SidebarLayoutProps {
  children?: ReactNode;
}

const SidebarLayout: FC<SidebarLayoutProps> = ({ children }) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', height: '100vh', bgcolor: 'background.default', position: 'relative', overflow: 'hidden' }}>
      {/* Floating Micro-interaction Background elements */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 0,
          pointerEvents: 'none',
          opacity: 0.4
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '10%',
            right: '5%',
            width: 400,
            height: 400,
            bgcolor: alpha(theme.palette.primary.main, 0.2),
            filter: 'blur(120px)',
            borderRadius: '50%'
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            bottom: '5%',
            left: '30%',
            width: 250,
            height: 250,
            bgcolor: alpha(theme.palette.secondary.main, 0.2),
            filter: 'blur(100px)',
            borderRadius: '50%',
            opacity: 0.5
          }}
        />
      </Box>

      {/* Sidebar */}
      <Sidebar />

      {/* Main Content Canvas */}
      <Box 
        sx={{ 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column', 
          zIndex: 1,
          overflowY: 'auto',
          [theme.breakpoints.up('lg')]: {
            ml: `280px`
          }
        }}
      >
        <Box sx={{ flex: 1, p: 3 }}>
          {children || <Outlet />}
        </Box>
        <Footer />
      </Box>
    </Box>
  );
};

export default SidebarLayout;
